import React from 'react';
import { Card, CardContent } from './ui/card';
import { CheckCircle2, Shield, FileCheck, Leaf } from 'lucide-react';

export const Quality = () => {
  const qualityFeatures = [
    {
      icon: <Leaf className="w-10 h-10 text-[#019645]" />,
      title: "Buenas Prácticas Agrícolas",
      description: "Implementamos buenas prácticas agrícolas (BPA) y de manufactura (BPM) con registros internos detallados de cada etapa del cultivo."
    },
    {
      icon: <FileCheck className="w-10 h-10 text-[#019645]" />,
      title: "Trazabilidad por Lote",
      description: "Sistema de trazabilidad que identifica cada lote con fecha de cosecha y parcela/finca de origen para máxima transparencia."
    },
    {
      icon: <Shield className="w-10 h-10 text-[#019645]" />,
      title: "Control de Calidad",
      description: "Inspecciones constantes durante todo el proceso productivo para garantizar productos que cumplan con los más altos estándares."
    },
    {
      icon: <CheckCircle2 className="w-10 h-10 text-[#019645]" />,
      title: "Inocuidad Alimentaria",
      description: "Manejo responsable de productos fitosanitarios y periodos de carencia adecuados para garantizar la seguridad alimentaria."
    }
  ];

  return (
    <section id="calidad" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Calidad e Inocuidad
          </h2>
          <div className="w-24 h-1 bg-[#019645] mx-auto mb-6"></div>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Comprometidos con la excelencia en cada etapa del proceso productivo
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
          {qualityFeatures.map((feature, index) => (
            <Card
              key={index}
              className="border-none shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-2"
            >
              <CardContent className="p-8">
                <div className="flex items-start">
                  <div className="p-3 bg-gray-50 rounded-lg mr-4 flex-shrink-0">
                    {feature.icon}
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-gray-900 mb-3">{feature.title}</h3>
                    <p className="text-gray-600 leading-relaxed">{feature.description}</p>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Certifications Banner */}
        <div className="bg-gradient-to-r from-[#019645] to-[#077c38] rounded-2xl shadow-2xl p-8 md:p-12 text-white">
          <div className="text-center mb-8">
            <h3 className="text-3xl font-bold mb-4">Nuestro Compromiso con la Calidad</h3>
            <p className="text-lg text-white/90 max-w-3xl mx-auto leading-relaxed">
              En GONSO mantenemos registros detallados de todas nuestras operaciones y trabajamos continuamente 
              en la mejora de nuestros procesos. Nos preparamos para cumplir con estándares internacionales 
              de exportación en los próximos años.
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-8">
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6 text-center hover:bg-white/20 transition-all duration-300">
              <div className="text-4xl font-bold mb-2">100%</div>
              <p className="text-white/90">Trazabilidad</p>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6 text-center hover:bg-white/20 transition-all duration-300">
              <div className="text-4xl font-bold mb-2">BPA</div>
              <p className="text-white/90">Implementamos Buenas Prácticas Agrícolas (BPA)</p>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6 text-center hover:bg-white/20 transition-all duration-300">
              <div className="text-4xl font-bold mb-2">+10</div>
              <p className="text-white/90">Años de Experiencia</p>
            </div>
          </div>

          {/* Disclaimer */}
          <div className="mt-8 pt-6 border-t border-white/20">
            <p className="text-sm text-white/70 text-center italic">
              Nota: Actualmente no contamos con una certificación oficial BPA.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
